import {dateString} from "../model/index.js";

/**
 * Returns a date string from the date given (or "now" if omitted). E.g. "2022-07-18T20:44:59Z"
 */
export function getDateString(date?: Date): dateString {
	return (date ?? new Date()).toISOString()
		.split(".", 2)[0] + "Z"; // This removes the milliseconds part. Ugly, yes, but works. Get sad: https://stackoverflow.com/a/34053802/368864
}
